module.exports = __webpack_public_path__ + "images/6f0ec88ac500f1264e25949bf163caf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/thesuperlatives-characters01.jpg
// module id = ./webpack/assets/img/thesuperlatives-characters01.jpg
// module chunks = 0